import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
@Injectable({
    providedIn: 'root'
})

export class PreviousRouteService {
    goto:any;
    listing_type:any;
    location:any;
    shouldModalOpen:boolean;
    pick:number;
    constructor(private router: Router) { }
}
